import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS, LANGS } from "../i18n/strings";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem("aristeia_lang");
    if (stored && STRINGS[stored]) return stored;
    return "es";
  });

  const setLang = (next) => {
    setLangState(next);
    localStorage.setItem("aristeia_lang", next);
    document.documentElement.lang = next;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => (key) => STRINGS[lang]?.[key] ?? key, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGS }), [lang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
